export default __webpack_public_path__ + "static/media/C-002.215cf9bd.png";